module.exports = parcelRequire.resolve("1o2rM");